const angular = require('angular');

const NewProductsService = require('./newproducts.service');
const newProductsNavigationDirectiveDefinition = require('./newproducts-navigation.directive');
const { newProductsTileListComponentDefinition } = require('./newproducts-tile-list.component');

angular.module('wowApp.shop')
    .service('NewProductsService', ['Restangular', NewProductsService])
    .directive('wowNewProductsNav', [newProductsNavigationDirectiveDefinition])
    .component('wowNewProductsTileList', newProductsTileListComponentDefinition);




// WEBPACK FOOTER //
// ./src/shop/newproducts/index.js